// Server-safe public API for Firebase/GA4 analytics. This file is statically imported into
// the SSR bundle (via _app.tsx), so it holds NO firebase imports itself. All firebase code
// lives in ./firebase-analytics-impl and is loaded lazily via dynamic import — which only
// ever runs client-side, so the browser-only @firebase/analytics package never evaluates
// during SSR. The import() is cached after the first call, so repeat calls are cheap.

// Kick off the async Analytics boot. No-op on the server; idempotent and self-gating in
// the impl. Safe to call from any event helper.
export const initFirebaseAnalytics = (): void => {
  if (typeof window === 'undefined') return;
  void import('./firebase-analytics-impl').then((m) => m.boot());
};

// Report a GA4 event. Boots Analytics on demand and queues the event until it's ready in
// the impl, so no caller can lose an event to the async config fetch; a no-op on the server.
export const logAnalyticsEvent = (eventName: string, params?: Record<string, unknown>): void => {
  if (typeof window === 'undefined') return;
  void import('./firebase-analytics-impl').then((m) => m.log(eventName, params));
};

/**
 * Hand this browser's GA4 `client_id` to the backend, so events our SERVERS produce (a renewal, a
 * credit grant) can reach this user's GA4 history through the Measurement Protocol. The native twin is
 * `SymphonyAnalyticsIdentity` on both phones.
 *
 * Fire-and-forget and a no-op on the server. Resolves `false` rather than throwing for every expected
 * outcome — analytics not booted, no consent, a visitor with no Orion account — and latches nothing
 * unless the backend accepted it, so the next load simply tries again.
 */
export const registerGa4Identity = (userId: string): void => {
  if (typeof window === 'undefined' || !userId) return;
  void import('./firebase-analytics-impl').then((m) => m.registerIdentity(userId));
};

/**
 * At checkout START, hand the backend the GA4 session this purchase happens in, so the server-side
 * `symphony_premium` event can carry its `session_id` and get a source instead of "(not set)". Called
 * from every web checkout start; fire-and-forget and a no-op on the server.
 */
export const registerGa4CheckoutSession = (): void => {
  if (typeof window === 'undefined') return;
  void import('./firebase-analytics-impl').then((m) => m.registerCheckoutSession());
};
